import { ReactNode } from "react";

type CardProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
  bodyClassName?: string;
  noPadding?: boolean;
  style?: React.CSSProperties;
  children: ReactNode;
};

/**
 * 汎用カード
 */
export const Card = ({
  title,
  subtitle,
  actions,
  className,
  bodyClassName,
  noPadding,
  style,
  children,
}: CardProps) => {
  return (
    <div
      className={`card ${noPadding ? "card-no-padding" : ""} ${className ?? ""}`}
      style={style}
    >
      {(title || actions) && (
        <div className="card-header" style={noPadding ? { padding: "16px 20px 0" } : undefined}>
          <div>
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <div className="card-subtitle">{subtitle}</div>}
          </div>
          {actions && <div className="card-actions">{actions}</div>}
        </div>
      )}
      <div className={bodyClassName} style={noPadding ? { padding: "0 20px 20px" } : undefined}>
        {children}
      </div>
    </div>
  );
};
